import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { SubmittalStatus } from '@/hooks/useSubmittals';

const statusConfig: Record<SubmittalStatus, { label: string; className: string }> = {
  draft:             { label: 'Draft',              className: 'bg-gray-100 text-gray-700 border-gray-200' },
  submitted:         { label: 'Submitted',          className: 'bg-blue-100 text-blue-800 border-blue-200' },
  approved:          { label: 'Approved',           className: 'bg-green-100 text-green-800 border-green-200' },
  approved_as_noted: { label: 'Approved as Noted',  className: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  revise_resubmit:   { label: 'Revise & Resubmit',  className: 'bg-orange-100 text-orange-800 border-orange-200' },
  rejected:          { label: 'Rejected',           className: 'bg-red-100 text-red-800 border-red-200' },
  closed:            { label: 'Closed',             className: 'bg-slate-600 text-white border-slate-600' },
};

interface SubmittalStatusBadgeProps {
  status: SubmittalStatus;
  className?: string;
}

export function SubmittalStatusBadge({ status, className }: SubmittalStatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.draft;
  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
